export const confirmPageTestId = "cdp-confirm-page";
export const multiInquiryModalModal = "aviv.CDP.Contacting.MultiInquiryModal";
